import React from "react"
import { useState } from "react"
import Header from 'app/layout/Header'
import Body from 'app/layout/Body'
import HeaderContext from 'app/HeaderContext';
import { HashRouter } from 'react-router-dom'

export default () => {
  const [text, setText] = useState("Dodo");
  const [menuContent, setMenuContent] = useState(null);

  const headerContextValue = { text, setText, menuContent, setMenuContent };

  return <HeaderContext.Provider value={headerContextValue}>
           <HashRouter>
             <div id="app" className="bg-landscape-01">
               <div className="content">
                 <Header text={text} />
                 <Body />
               </div>
             </div>
           </HashRouter>
         </HeaderContext.Provider>
}
